/** @format */
import { ConcatProps } from 'src/components/AlarmReciver/new'
import yaml from 'js-yaml'
import { mapKeys, isEqual } from 'lodash'
import { CallbackValueProp } from 'src/components/AlarmCallBack/new'

// 告警规则
export interface EditPolicyRuleProps {
  Expand?: boolean // 展开/收起
  State: boolean | number // 规则启停状态
  RuleID: number // 规则ID
  Alert: string // 规则名称
  Expr: string // 规则表达式
  For: number | string // 持续时间
  ForUnit?: 'm' | 'h' // 持续时间单位
  Labels: { Name: string; Value: string }[]
  Annotations: { Name: string; Value: string }[]
}
export const initEditPolicyRule: EditPolicyRuleProps = {
  Expand: true,
  State: 1,
  RuleID: 0,
  Alert: '',
  Expr: '',
  For: 0,
  ForUnit: 'm',
  Labels: [{ Name: 'severity', Value: '' }],
  Annotations: [
    { Name: 'summary', Value: '' },
    { Name: 'description', Value: '' }
  ]
}

export const initYaml =
  // eslint-disable-next-line max-len
  'rules:\n  - alert: HighRequestLatency #规则名称,必填\n    expr: job:request_latency_seconds:mean5m{job="myjob"} > 0.5  #规则,必填\n    for: 10m #持续时间,选填。单位：m(分钟)或者h(小时)\n    labels:\n      severity: critical #告警等级,必填，枚举值：critical/warning/error\n      version: 1.0 # 用户自定义标签示例\n    annotations:\n      summary: High request latency #告警摘要,必填\n      description: High request latency #告警内容,必填\n      region: beijing # 用户自定义注解示例'
// 告警模板
export interface EditTemplateProps {
  CreateType?: 'page' | 'yaml'
  Name: string
  Rules: EditPolicyRuleProps[]
  Yaml?: string
}
export const initTemplateValues: EditTemplateProps = {
  CreateType: 'page',
  Name: '',
  Rules: [initEditPolicyRule],
  Yaml: ''
}

// 告警策略
export interface EditPolicyProps extends EditTemplateProps {
  PolicyType?: number
  InstanceIDs?: string[]
  WebHooks?: string[]
  URLNotices?: CallbackValueProp[]
  Recipients?: ConcatProps[]
  SaveAsTemplate?: boolean
  TemplateName?: string
}
export const initPolictValues: EditPolicyProps = {
  CreateType: 'page',
  InstanceIDs: [],
  Name: '',
  Rules: [initEditPolicyRule],
  Yaml: '',
  Recipients: [],
  URLNotices: [],
  // EffectiveType: 1,
  // EffectiveStartTime: '00:00',
  // EffectiveEndTime: '23:59',
  SaveAsTemplate: false,
  TemplateName: ''
}

export const jsonToYaml = (json: EditPolicyRuleProps[]) => {
  const result = json.map(item => {
    const labels = {}
    item.Labels.forEach(item => {
      labels[item.Name] = item.Value
    })
    const annotations = {}
    item.Annotations.forEach(item => {
      annotations[item.Name] = item.Value
    })
    const rule = {
      Alert: item.Alert,
      Expr: item.Expr,
      For: item.For + (item.ForUnit ? item.ForUnit : ''),
      Labels: labels,
      Annotations: annotations
    }
    return rule
  })
  const toLower = keysToLowerLodash(result)
  return yaml.dump({ rules: toLower })
}

const keysToLowerLodash = obj => {
  if (Array.isArray(obj)) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return obj.map(v => keysToLowerLodash(v))
  } else if (obj !== null && typeof obj === 'object') {
    return mapKeys(obj, (v, k) => k.toLowerCase())
  }
  return obj
}

// 验证页面编辑的表单是否全部没填
export const validateEditEmpty = (rules: EditPolicyRuleProps[]) => {
  if (rules?.length === 1) {
    const [{ Alert, Expr, For, Labels, Annotations }] = rules
    if (
      Alert === '' &&
      Expr === '' &&
      For === 0 &&
      isEqual(Labels, initEditPolicyRule.Labels) &&
      isEqual(Annotations, initEditPolicyRule.Annotations)
    ) {
      return true
    }
    return false
  } else {
    return false
  }
}
